import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row } from 'antd';
import { TMenuRowProps } from './definitions';
import Styles from './MenuRow.module.scss';
import KALogo from '../../Atoms/KALogo';
import Divider from '../../Atoms/Divider';
import { joinClassnames } from 'helpers/classNames';
import Text from 'Pages/Home/Components/Atoms/Text';

import ChevronRightImage from 'images/black-mii-right.png';
import ChevronLeftImage from 'images/black-mii-left.png';
import Image from 'Pages/Home/Components/Atoms/Image';

export default function MenuRow({
  type,
  withMarginHorizontal,
  text,
  onClick,
  isDetail,
}: TMenuRowProps) {
  if (type === 'logo')
    return (
      <div
        className={joinClassnames(
          Styles['menu-row'],
          withMarginHorizontal ? Styles['with-horizontal-margin'] : '',
        )}
      >
        <Row
          align="middle"
          justify="center"
          className={joinClassnames(
            Styles['menu-row-item'],
            !withMarginHorizontal ? Styles['with-horizontal-padding'] : '',
          )}
        >
          <KALogo />
        </Row>
        <Divider />
      </div>
    );

  if (type === 'title')
    return (
      <div
        className={joinClassnames(
          Styles['menu-row'],
          withMarginHorizontal ? Styles['with-horizontal-margin'] : '',
        )}
        onClick={onClick}
      >
        <Row
          align="middle"
          className={joinClassnames(
            Styles['menu-row-item'],
            !withMarginHorizontal ? Styles['with-horizontal-padding'] : '',
          )}
        >
          <Image
            src={ChevronLeftImage}
            className={joinClassnames(
              Styles['menu-row-item-image'],
              Styles['with-margin-right'],
            )}
          />
          <Text className={Styles['menu-row-item-text']}>{text}</Text>
        </Row>
        <Divider />
      </div>
    );

  return (
    <div
      className={joinClassnames(
        Styles['menu-row'],
        withMarginHorizontal ? Styles['with-horizontal-margin'] : '',
      )}
      onClick={onClick}
    >
      <Row
        align="middle"
        justify="space-between"
        className={joinClassnames(
          isDetail ? Styles['menu-row-item-detail'] : Styles['menu-row-item'],
          !withMarginHorizontal ? Styles['with-horizontal-padding'] : '',
        )}
      >
        <Text className={Styles['menu-row-item-text']}>{text}</Text>
        <Image
          src={ChevronRightImage}
          className={Styles['menu-row-item-image']}
        />
      </Row>
      <Divider />
    </div>
  );
}
